import { Injectable } from "@angular/core";
import { LoadingController } from "ionic-angular";
import { isEmpty } from "lodash";

@Injectable()
export class SpinnerService {
  private _loading: any;
  constructor(public loadingCtrl: LoadingController) {}

  start(customLoadingText: string) {
    if (!isEmpty(customLoadingText) || !this._loading) {
      this._loading = this.loadingCtrl.create({
        content: customLoadingText || "Please wait...",
        duration: 18000,
      });
    }
    this._loading.present();
  }

  stop() {
    if (this._loading) {
      this._loading.dismiss();
      this._loading = null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/spinnerService/spinnerService.ts